import { render, staticRenderFns } from "./reporteCasino.vue?vue&type=template&id=2c20574c&"
import script from "./reporteCasino.vue?vue&type=script&lang=js&"
export * from "./reporteCasino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports